import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import ParticlesFlickeringIntensityListItem from './ParticlesFlickeringIntensityListItem';
import ParticlesReactiveFlickerListItem from './ParticlesReactiveFlickerListItem';

const ParticlesFlickeringListItem = (props) => {
    const { flickering, index, updateParticleElement } = props;

    const onFlickeringChange = (checked) => {
        updateParticleElement(index, { 
            flickering: { 
                ...flickering, 
                enabled: checked 
            } 
        });
    };

    return (
        <CollapsibleSwitchListItem
            text='Flicker'
            checked={flickering?.enabled || false}
            onChange={onFlickeringChange}
        >
            <ParticlesReactiveFlickerListItem index={index} />
            <ParticlesFlickeringIntensityListItem index={index} />
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];

    return {
        flickering: particleElement.flickering || {}
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesFlickeringListItem);
